module.exports = __webpack_public_path__ + "img/check.213dc0ed.png";